import script from "./BuildingProgressCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingProgressCard.vue?vue&type=script&setup=true&lang=js"

import "./BuildingProgressCard.vue?vue&type=style&index=0&id=774a6b73&lang=css"

const __exports__ = script;

export default __exports__